<script>
import Radio from "@/pages/components/form/horizontal/radio.vue";
import FormGroup from "@/pages/components/form/horizontal/form-group.vue";
import formInput from "@wielink-application/shared/js/mixins/formInput";

export default {
  mixins: [formInput],
  components: {Radio, FormGroup},
  props: {
    label: {
      type: String
    }
  }
}
</script>

<template>
  <FormGroup groupClasses="align-items-center">
    <template v-if="label" #label>
      {{ label }}
    </template>

    <div class="d-flex gap-3">
      <Radio @update:modelValue="$emit('update:modelValue', $event)" :model-value="modelValue" :form="form" :name="name" :id="`${this.renderedId}-1`" value="1" label="Ja"/>
      <Radio @update:modelValue="$emit('update:modelValue', $event)" :model-value="modelValue" :form="form" :name="name" :id="`${this.renderedId}-2`" value="0" label="Nee"/>
    </div>
  </FormGroup>
</template>